import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4e54c6f8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "notification-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon" }, null, -1))
const _hoisted_3 = { class: "dropdown-container" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("summary", null, null, -1))
const _hoisted_5 = { class: "dropdown-content" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header" }, " 알림 ", -1))
const _hoisted_7 = ["onClick"]
const _hoisted_8 = {
  key: 0,
  class: "no-notification"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_comment_notification_item = _resolveComponent("comment-notification-item")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _withDirectives(_createElementVNode("div", { class: "count" }, _toDisplayString(_ctx.notifications.length), 513), [
      [_vShow, _ctx.notifications.length > 0]
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("details", null, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notifications, (notification, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["notification-item", { last: index == _ctx.notifications.length - 1 }]),
              key: notification.id
            }, [
              (notification.notificationType == 'COMMENT')
                ? (_openBlock(), _createBlock(_component_comment_notification_item, {
                    key: 0,
                    notification: notification
                  }, null, 8, ["notification"]))
                : _createCommentVNode("", true),
              _createElementVNode("button", {
                onClick: ($event: any) => (_ctx.deleteNotification(notification.id))
              }, "삭제", 8, _hoisted_7)
            ], 2))
          }), 128)),
          (_ctx.notifications.length == 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, " 새로운 알림이 없습니다. "))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}